export default function getV2NavigationFallback() {
  return {
    viewMap: {
      COLLECTION: {
        default: {
          viewId: 'playlist',
          entityType: 'COLLECTION',
          entitySubtype: 'default',
          viewType: 'COLLECTION',
          url: '/playlist/{{contentObj.siteSlug}}',
        },
        PLAYLIST: {
          viewId: 'playlist',
          entityType: 'COLLECTION',
          entitySubtype: 'PLAYLIST',
          viewType: 'COLLECTION',
          url: '/playlist/{{contentObj.siteSlug}}',
        },
      },
      STATION: {
        default: {
          viewId: 'testTemplate',
          entityType: 'STATION',
          entitySubtype: 'default',
          viewType: 'STATION',
          url: '/stations/testTemplate/{{contentObj.siteSlug}}',
        },
        BROADCAST_RADIO: {
          viewId: 'stations',
          entityType: 'STATION',
          entitySubtype: 'BROADCAST_RADIO',
          viewType: 'STATION',
          url: '/stations/{{contentObj.siteSlug}}',
        },
        EXCLUSIVE_STATION: {
          viewId: 'stations',
          entityType: 'STATION',
          entitySubtype: 'EXCLUSIVE_STATION',
          viewType: 'STATION',
          url: '/stations/{{contentObj.siteSlug}}',
        },
        INTERNET_RADIO: {
          viewId: 'stations',
          entityType: 'STATION',
          entitySubtype: 'INTERNET_RADIO',
          viewType: 'STATION',
          url: '/stations/{{contentObj.siteSlug}}',
        },
      },
      CHAPTER: {
        default: {
          viewId: 'chapters',
          entityType: 'CHAPTER',
          entitySubtype: 'default',
          viewType: 'CHAPTER',
          url: '/stations/{{contentObj.parentStation.siteSlug}}/shows/{{contentObj.parentShow.siteSlug}}/episodes/{{contentObj.parentEpisode.siteSlug}}/chapters/{{contentObj.siteSlug}}',
        },
        BROADCAST_EPISODE_CHAPTER: {
          viewId: 'chapters',
          entityType: 'CHAPTER',
          entitySubtype: 'BROADCAST_EPISODE_CHAPTER',
          viewType: 'CHAPTER',
          url: '/stations/{{contentObj.parentStation.siteSlug}}/shows/{{contentObj.parentShow.siteSlug}}/episodes/{{contentObj.parentEpisode.siteSlug}}/chapters/{{contentObj.siteSlug}}',
        },
      },
      EPISODE: {
        BROADCAST_SHOW_EPISODE: {
          viewId: 'episodes',
          entityType: 'EPISODE',
          entitySubtype: 'BROADCAST_SHOW_EPISODE',
          viewType: 'EPISODE',
          url: '/stations/{{contentObj.parentStation.siteSlug}}/shows/{{contentObj.parentShow.siteSlug}}/episodes/{{contentObj.siteSlug}}',
        },
        PODCAST_EPISODE: {
          viewId: 'episodes',
          entityType: 'EPISODE',
          entitySubtype: 'PODCAST_EPISODE',
          viewType: 'EPISODE',
          url: '/podcast/{{contentObj.parentShow.siteSlug}}/episodes/{{contentObj.siteSlug}}',
        },
        default: {
          viewId: 'episodes',
          entityType: 'EPISODE',
          entitySubtype: 'default',
          viewType: 'EPISODE',
          url: '/stations/{{contentObj.parentStation.siteSlug}}/shows/{{contentObj.parentShow.siteSlug}}/episodes/{{contentObj.siteSlug}}',
        },
        HOST_CREATED_EPISODE: {
          viewId: 'episodes',
          entityType: 'EPISODE',
          entitySubtype: 'HOST_CREATED_EPISODE',
          viewType: 'EPISODE',
          url: '/stations/{{contentObj.parentStation.siteSlug}}/shows/{{contentObj.parentShow.siteSlug}}/episodes/{{contentObj.siteSlug}}',
        },
      },
      SHOW: {
        default: {
          viewId: 'shows',
          entityType: 'SHOW',
          entitySubtype: 'default',
          viewType: 'SHOW',
          url: '/stations/{{contentObj.parentStation.siteSlug}}/shows/{{contentObj.siteSlug}}',
        },
        DIGITAL_ONLY: {
          viewId: 'shows',
          entityType: 'SHOW',
          entitySubtype: 'DIGITAL_ONLY',
          viewType: 'SHOW',
          url: '/stations/{{contentObj.parentStation.siteSlug}}/shows/{{contentObj.siteSlug}}',
        },
        BROADCAST_SHOW: {
          viewId: 'shows',
          entityType: 'SHOW',
          entitySubtype: 'BROADCAST_SHOW',
          viewType: 'SHOW',
          url: '/stations/{{contentObj.parentStation.siteSlug}}/shows/{{contentObj.siteSlug}}',
        },
        PODCAST: {
          viewId: 'podcasts',
          entityType: 'SHOW',
          entitySubtype: 'PODCAST',
          viewType: 'SHOW',
          url: '/podcast/{{contentObj.siteSlug}}',
        },
      },
      TAG: {
        default: {
          viewId: 'music',
          entityType: 'TAG',
          entitySubtype: 'default',
          viewType: 'TAG',
          url: '/music/{{contentObj.siteSlug}}',
        },
        League: {
          viewId: 'sportsleagues',
          entityType: 'TAG',
          entitySubtype: 'League',
          viewType: 'TAG',
          url: '/sports/{{contentObj.siteSlug}}',
        },
        Category: {
          viewId: 'stations_category',
          entityType: 'TAG',
          entitySubtype: 'Category',
          viewType: 'TAG',
          url: '/stations/category/{{contentObj.siteSlug}}',
        },
        Team: {
          viewId: 'sportsteams',
          entityType: 'TAG',
          entitySubtype: 'Team',
          viewType: 'TAG',
          url: '/sports/{{contentObj.parentTag.siteSlug}}/{{contentObj.siteSlug}}',
        },
        Genre: {
          viewId: 'music',
          entityType: 'TAG',
          entitySubtype: 'Genre',
          viewType: 'TAG',
          url: '/music/{{contentObj.siteSlug}}',
        },
      },
      TOPIC: {
        MUSIC: {
          viewId: 'music',
          entityType: 'TOPIC',
          entitySubtype: 'MUSIC',
          viewType: 'TOPIC',
          url: '/music/{{contentObj.siteSlug}}',
        },
        SPORTS: {
          viewId: 'sports',
          entityType: 'TOPIC',
          entitySubtype: 'SPORTS',
          viewType: 'TOPIC',
          url: '/sports/{{contentObj.siteSlug}}',
        },
        NEWS: {
          viewId: 'news',
          entityType: 'TOPIC',
          entitySubtype: 'NEWS',
          viewType: 'TOPIC',
          url: '/news/{{contentObj.siteSlug}}',
        },
        CITIES: {
          viewId: 'cities',
          entityType: 'TOPIC',
          entitySubtype: 'CITIES',
          viewType: 'TOPIC',
          url: '/cities/{{contentObj.siteSlug}}',
        },
        PODCASTS: {
          viewId: 'podcast_genre',
          entityType: 'TOPIC',
          entitySubtype: 'PODCASTS',
          viewType: 'TOPIC',
          url: '/podcast/genre/{{contentObj.siteSlug}}',
        },
        NFLTEAM: {
          viewId: 'sports_nfl',
          entityType: 'TOPIC',
          entitySubtype: 'NFLTEAM',
          viewType: 'TOPIC',
          url: '/sports/nfl-72392/{{contentObj.siteSlug}}',
        },
      },
      GEOGRAPHY: {
        MARKET: {
          viewId: 'locations',
          entityType: 'GEOGRAPHY',
          entitySubtype: 'MARKET',
          viewType: 'MODULES',
          url: 'https://webclient-stg.audacy.com/stations/location/{{contentObj.siteSlug}}',
        },
      },
    },
    tabs: [
      {
        iconRef: 'Logo',
        label: 'Home',
        viewId: 'home',
        viewType: 'MODULES',
      },
      {
        iconRef: 'Search',
        label: 'Search',
        viewId: 'search',
        viewType: 'SEARCH',
      },
      {
        iconRef: 'Profile',
        label: 'My Audio',
        viewId: 'myAudio',
        viewType: 'MY_AUDIO',
      },
    ],
    global: {
      legalTermsOfUse: 'legalTermsOfUse',
      registrationEmailPassword: 'registrationEmailPassword',
      myAudioQueue: 'myAudioQueue',
      profileSecurity: 'profileSecurity',
      registrationName: 'registrationName',
      ForYouTabs: 'home|sports|podcast|music',
      profileOpenSource: 'profileOpenSource',
      developerScreen: 'developerScreen',
      profileContactSupport: 'profileContactSupport',
      login: 'login',
      carPlayLoggedOut: 'carPlayLoggedOut',
      registrationFacebookEmailError: 'registrationFacebookEmailError',
      selectAuthMethod: 'selectAuthMethod',
      search: 'search',
      accountReactivateRequest: 'accountReactivateRequest',
      registrationAdditionalDetails: 'registrationAdditionalDetails',
      resetPasswordCreateNewPassword: 'resetPasswordCreateNewPassword',
      profileOverview: 'profileOverview',
      resetPasswordEnterEmail: 'resetPasswordEnterEmail',
      player: 'player',
      profilePassword: 'profilePassword',
      resetPasswordCheckEmail: 'resetPasswordCheckEmail',
      onboardingStations: 'onboardingStations',
      profileAccount: 'profileAccount',
      myAudioStations: 'myAudioStations',
      schedule: 'schedule',
      legalPrivacyPolicy: 'legalPrivacyPolicy',
      profileLocation: 'profileLocation',
      carPlayRecentsList: 'carPlayRecentsList',
      landing: 'landing',
      deleteConfirmation: 'deleteConfirmation',
      migration: 'migration',
      profileDelete: 'profileDelete',
      contactAudacy: 'contact',
      profileNotification: 'profileNotification',
      registrationCreatePassword: 'registrationCreatePassword',
      allEpisodes: 'episodes',
      myAudioTopics: 'myAudioTopics',
      myAudioPodcastsAndShows: 'myAudioPodcastsAndShows',
      myAudioRecent: 'myAudioRecent',
      queue: 'queueOverlay',
      privacyLegal: 'privacyLegal',
    },
  };
}
